import React from 'react';
import useSessionInfoContext from '../SessionInfoContextProvider/useSessionInfoContext';
import EndSessionDialog from './EndSessionDialog';

export default function EndSessionDialogWrapper({ children }: { children: React.ReactNode }) {
  const [endSessionDialogOpen, setEndSessionDialogOpen] = React.useState(null);
  const { endCause, sessionId } = useSessionInfoContext();

  React.useEffect(() => {
    if (endCause) {
      setEndSessionDialogOpen(sessionId);
    }
  }, [endCause]);

  return (
    <>
      {children}
      <EndSessionDialog open={endSessionDialogOpen} onClose={() => { setEndSessionDialogOpen(null); }} />
    </>
  );
}
